import React, { useState } from 'react';
import { CheckSquare, ChevronDown, ChevronRight, Square } from 'lucide-react';

export function AssignmentPicker({ destId, items, selected, onToggle, onSetAll }) {
  const [open, setOpen] = useState(false);
  if (!items?.length) return null;
  return (
    <div className="text-xs space-y-1" data-testid={`assign-picker-${destId}`}>
      <div className="flex items-center gap-3">
        <button className="flex items-center gap-1 font-medium text-green-700 hover:underline"
          onClick={() => setOpen(v => !v)} data-testid={`assign-toggle-${destId}`}>
          {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
          Products to assign — {selected.size} of {items.length} selected
        </button>
        <button type="button" className="flex items-center gap-1 text-slate-700"
          onClick={() => onSetAll(items.map(i => i.product_id))} data-testid={`assign-select-all-${destId}`}>
          <CheckSquare className="h-3.5 w-3.5" /> Select all
        </button>
        <button type="button" className="flex items-center gap-1 text-slate-500"
          onClick={() => onSetAll([])} data-testid={`assign-deselect-all-${destId}`}>
          <Square className="h-3.5 w-3.5" /> Deselect all
        </button>
      </div>
      {open && (
        <div className="max-h-72 overflow-y-auto pl-4 border-l border-slate-200">
          {items.map(item => (
            <label key={item.product_id} className="flex items-center gap-2 py-0.5 cursor-pointer"
              data-testid={`assign-item-${destId}-${item.product_id}`}>
              <input type="checkbox" checked={selected.has(item.product_id)} onChange={() => onToggle(item.product_id)} />
              <span className="font-mono text-slate-400">{item.product_code}</span>
              <span className="text-slate-700 truncate">{item.product_name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
